export default __webpack_public_path__ + "static/media/you_did_it.f8b5f05d.mp3";